var _path, _mask, _rect, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.64987 8L17.3501 8L20.4612 15L3.53876 15L6.64987 8Z",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_257_9120",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 2,
    width: 8,
    height: 7,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 2,
    width: 8,
    height: 7,
    rx: 1,
    strokeWidth: 4,
    mask: "url(#path-2-inside-1_257_9120)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18L7.7396 18.3906C7.29173 19.0624 7.29173 19.9376 7.7396 20.6094L8 21",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18L11.7396 18.3906C11.2917 19.0624 11.2917 19.9376 11.7396 20.6094L12 21",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18L15.7396 18.3906C15.2917 19.0624 15.2917 19.9376 15.7396 20.6094L16 21",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHood);
export default __webpack_public_path__ + "static/media/Hood.a8ae9f9ed0ea9296186fbf1f72d3bd42.svg";
export { ForwardRef as ReactComponent };